module.exports = __webpack_public_path__ + "static/quizbaker4-529b7ff898a7f0d72de4140c9e424d9d.png";